import { lazy } from 'react';

const Content = lazy(() => import('./Content'));

export { Content };
